// extracted by mini-css-extract-plugin
export default {"root":"HeaderSection_root__nN3Go","title":"HeaderSection_title__MLQaT","text":"HeaderSection_text__AVV3h"};